import { useState } from "react";
import { AddIcon } from "../../../assets/icons";
import { GetAccess } from "../../../utils/RolesandAccess";
import useFetchMetaData from "../../../hooks/useFetchMetaData";
import UseGetInsideData from "../../../hooks/useFetchInsideData";
import { TableLoader } from "../../../components/Loader";
import useFetchStandard from "../../../hooks/usFetchStandard";
import CreateorUpdate from "./form";
import Viewmore from "./viewMore";

function UserManagementIndex() {
  const { data, getData, isLoading } = UseGetInsideData({ url: "/User/" });
  const [showMyModal, setShowMyModal] = useState(false);
  const {metaData} = useFetchMetaData({value:'department_type'})
  const {standardList} = useFetchStandard()


  return (
    <>
      <div className=" w-full h-[calc(100vh-140px)] overflow-y-auto">
        <div className="pb-2 px-2 flex justify-between items-center w-full">
          <h4 className="text-sm 2xl:text-base font-medium text-heading">
            User Managment
          </h4>
          <div className=" w-8 flex justify-center items-center cursor-pointer">
            {GetAccess("admin_create") && (
              <div onClick={() => setShowMyModal(true)}>
                <AddIcon />
              </div>
            )}
          </div>
        </div>
        <div className=" w-full h-[calc(100vh-180px)]  relative overflow-y-auto">
          <div className=" sticky top-0">
            <table className="table-auto w-full">
              <thead className="bg-tabletitle">
                <tr className="flex items-center text-xs 2xl:text-sm font-medium">
                  {header?.map((header) => (
                    <th className={`text-center px-5 py-4 ${header.width}`}>
                      {header?.headone}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          </div>
          <div>
            <table className="table-auto w-full">
              {isLoading == true ? <>
                {[...Array(8)].map((_, index) => {
                return <TableLoader key={index} header={header}  />;
              })}
              </> : <>
              {
                data?.userDetails && data?.userDetails.map((data,i)=>(
                    <tr className="odd:bg-tableodd w-full even:bg-tableeven text-xs 2xl:text-sm py-1 flex justify-between items-center my-1" key={i}>
                        <td className={`text-center text-gray-900 py-1 w-[10%]`}>
                        {data.number||"#"} 
                        </td>
                        <td className={`text-center text-gray-900 py-1 w-[20%]`}>
                        {data?.user?.name||"-"} 
                        </td>
                        <td className={`text-center text-gray-900 py-1 w-[20%]`}>
                        {data?.user?.user_name||"-"} 
                        </td>
                        <td className={`text-center text-gray-900 py-1 w-[25%]`}>
                        {data?.user?.email||"-"}
                        </td>
                        <td className={`text-center text-gray-900 py-1 w-[20%]`}>
                        {data?.user?.mobile||"-"} 
                        </td>
                        <td className={`text-center text-gray-900 py-1 w-[5%]`}>
                          <div className=" w-full h-full flex justify-center items-center">
                          <Viewmore
                           data={data?.user} 
                           viewData={data}
                           fetcher={getData}
                           standard={standardList}
                           depList={metaData}
                         />
                          </div> 
                        </td>
                    </tr>
                ))
              }
              </>}
            </table>
          </div>
        </div>
      </div>
      <CreateorUpdate
        standard={standardList}
        onClose={() => setShowMyModal(false)}
        visible={showMyModal}
        refreshData={getData}
        depList={metaData}
      />
    </>
  );
}

export default UserManagementIndex;

const header = [
  {
    headone: "SI. No",
    width: "w-[10%]",
  },
  {
    headone: "Name",
    width: "w-[20%]",
  },
  {
    headone: "User Name",
    width: "w-[20%]",
  },
  {
    headone: "Email",
    width: "w-[25%]",
  },
  {
    headone: "Mobile",
    width: "w-[20%]",
  },
  {
    headone: " ",
    width: "w-[5%]",
  },
];
